import VideoPlayer from './modules/Elements/VideoPlayer.js';
import {ComScore} from './modules/Classes/LoggingIntegrations.js';
import eventOptions from './modules/Functions/eventOptions.js';
import AC_ID from './modules/Classes/AC_ID.js';
import installResonateLoader from './modules/Functions/installResonateLoader.js';
import topWindowWithSameOrigin from './modules/Functions/topWindowWithSameOrigin.js';
import version from './version.js';
import urlQueryToObject from './modules/Functions/urlQueryToObject.js';

if(config.isModule)
{
	console.log(`SendtoNews Player.js Version: ESModules - ${version}`);
}
else
{
	console.log(`SendtoNews Player.js Version: WebPack - ${version}`);
}

// Because the promises are made originally from outside the iframe, they may be basterdized promises from strange polyfills.
// They should still be "thenable" atleast, so wrap the potentially bad promise in a known good promise.

for(const name in config.scripts)
{
	if(config.scripts.hasOwnProperty(name))
	{
		config.scripts[name] = Promise.resolve(config.scripts[name]);
	}
}

for(const name in config.styles)
{
	if(config.styles.hasOwnProperty(name))
	{
		config.styles[name] = Promise.resolve(config.styles[name]);
	}
}

/** @namespace config */

const isMobile = config.isMobile = (config.feed.platform || '').toLowerCase() === 'mobile';
config.ac_id = new AC_ID();
config.scripts.comScore.then( () => new ComScore(window) );

// float percent determines float and playOnVisible, so process it first
config.feed.floatPercent = parseFloat(config.feed['ESG_floatPercent']);

// set player type based off of the data-type attribute
config.feed.playerType = config.divTag.getAttribute('data-type');
if(config.feed.playerType)
{
	config.feed.playerType = config.feed.playerType.toUpperCase();
	// whitelist the available player types
	switch(config.feed.playerType)
	{
		case 'FLOAT':
		case 'BARKER':
		case 'SINGLE':
		case 'FULL':
			break;
		default:
			config.feed.playerType = null;
	}
}

// if there is no whitelisted player type in the div tag
if(!config.feed.playerType)
{
	// then check the feed values
	switch(config.feed['ESG_playerType'].toUpperCase().slice(0, 4))
	{
		case 'FLOA':
			config.feed.playerType = 'FLOAT';
			break;
		case 'BARK':
			config.feed.playerType = 'BARKER';
			break;
		case 'SING':
			config.feed.playerType = 'SINGLE';
			break;
		default:
			config.feed.playerType = 'FULL';
			break;
	}
}

// player type sets float status
config.feed.float =
(
	(
		config.feed.playerType === 'FLOAT' ||
		(
			config.feed.playerType === 'BARKER' &&
			config.feed['ESG_enableBarkerFloat'] === 'YES'
		)
	)
	&&
	(
		!isMobile ||
		config.feed['ESG_enableMobileFloat'] === 'YES'
	)
);

// if this setting is set to NO and there is no document referrer, disable all the floats
config.feed.disableAllFloats =
	config.feed['ESG_directLoadFloat'] === 'NO' &&
	(
		!topWindowWithSameOrigin().document.referrer ||
		urlQueryToObject(topWindowWithSameOrigin().document.location.search,true)['stn'] === 'nf'
	);

if(config.feed.disableAllFloats)
{
	if(config.feed.playerType === 'FLOAT')
	{
		config.feed.playerType = 'FULL';
	}
	config.feed.float = false;
}

// float stuff
config.feed.floatOnLoad =
(
	!config.feed.disableAllFloats && config.feed.float &&
	(config.feed['ESG_floatOnLoad'] === 'YES' || config.feed.floatPercent < 1) &&
	( !isMobile || config.feed['ESG_floatOnLoadMobile'] === 'YES' )
);

config.feed.floatOnLoadScrollDelay = config.feed.floatOnLoad && !isMobile && config.feed.floatPercent && config.feed.floatPercent!==1 && config.feed.floatPercent * 1000 || 0;
config.feed.floatOnce = config.feed['ESG_floatOnce'] === 'YES';

config.feed.floatWidth =
(
	isMobile ?
	(config.feed['ESG_mobileFloatWidth'] || 0.6) :
	(config.feed['ESG_floatingWidth'] * 1 || 400 )
);

config.feed.floatPosition =
(
	(
		isMobile ?
		// if we are mobile, use database setting
		config.feed['ESG_mobileFloatPosition'] :
		// if we are desktop
		(
			// use the div tag parameter
			config.divTag.getAttribute('data-float-position') ||
			// fallback to the database
			config.feed['ESG_floatingPosition']
		)
	)
	|| ''
)
.split('-').join(' ').toLowerCase() || 'bottom right';

config.feed.floatOffset =
(
	isMobile ?
	[
		config.feed['ESG_mobileOffsetX'],
		config.feed['ESG_mobileOffsetY']
	]
		:
	[
		config.divTag.hasAttribute('data-float-x') ?
			config.divTag.getAttribute('data-float-x') :
			config.feed['ESG_offsetX']
		,
		config.divTag.hasAttribute('data-float-y') ?
			config.divTag.getAttribute('data-float-y') :
			config.feed['ESG_offsetY']
	]
)
.map( v => parseInt(v) )
.map( v => ( !v && v !== 0 ) ? ( isMobile?0:10 ) : v );

config.feed.smartPlayer = config.feed['ESG_smartPlayer'] === 'YES';

const floatParamsElement = frameElement.parentElement.parentElement;
const floatElement = floatParamsElement.parentElement;

floatElement.setAttribute('data-float-position',config.feed.floatPosition);

function onResize()
{
	const currentDocumentWidth = config.divTag.ownerDocument.documentElement.clientWidth;
	if(onResize.previousDocumentWidth === currentDocumentWidth)
	{
		return;
	}
	onResize.previousDocumentWidth = currentDocumentWidth;

	if(onResize.widthSet && !config.isMobile)
	{
		return;
	}

	onResize.widthSet = true;

	floatParamsElement.style.width =
	(
		config.isMobile ?
		(currentDocumentWidth * config.feed.floatWidth + 'px') :
		(config.feed.floatWidth + 'px')
	);
}
config.divTag.ownerDocument.defaultView.addEventListener('resize',onResize,eventOptions({capture:true}));
onResize();

floatParamsElement.style.margin = config.feed.floatOffset.reverse().map(v => v+'px').join(' ');

// if float, play on visible, so process play on visible stuff
// play on visible stuff
config.feed.playOnVisible = config.feed.float || !config.feed.disableAllFloats && ( config.feed['ESG_playOnVisible'] === 'YES' || config.feed.floatPercent === 0 );
config.feed.playOnVisiblePercent = ((config.feed['ESG_minVisRatio'] || 0) * 100) || 50;
config.feed.playOnVisibleNoResume = config.feed['ESG_playOnVisibleNoResume'] === 'YES';

delete config.feed.floatPercent;

switch(config.feed['ESG_playerAutoplay'])
{
	case 'YES':
		config.feed.autoplay = true;
		break;
	case 'NO':
		config.feed.autoplay = false;
		break;
	default:
		config.feed.autoplay = null;
}

// play on visible sets autoplay, so it's next
if(config.feed.playOnVisible || config.feed.disableAllFloats)
{
	config.feed.autoplay = true;
}

if(isMobile && config.feed['ESG_mobileAutoplay']==='YES' && !config.feed.floatOnLoad)
{
	config.feed.playOnVisible = false;
}

if(config.feed.autoplay === null && config.feed.playerType === 'SINGLE' && config.divTag.hasAttribute('data-sc-autoplay'))
{
	config.feed.autoplay = true;
}

// misc settings
config.feed.barkerTitle = config.feed['ES_GROUP_altText'];
config.feed.redSkin = (config.feed['ESG_skin']||'').includes('usatoday') || config.feed['ESG_skin'] === 's2n_light';
// title bar defaults to off for the red light skin, but can be overridden
switch(config.feed['ESG_noTitle'])
{
	case 'YES':
		config.feed.noTitle = true;
		break;
	case 'NO':
		config.feed.noTitle = false;
		break;
	default:
		config.feed.noTitle = config.feed.redSkin;
}
config.feed.enableAdUnitSuffix = config.feed['ESG_enableAdUnitTest'] === 'YES';
config.feed.enableResonate = config.feed['ESG_disableResonate'] !== 'YES';
config.feed.prebid = config.feed['ESG_enableSpotXHeaderBidding'] === 'YES';
config.feed.prebidEnableBidders = config.feed['ESG_prebidEnableBidders'] || [];
config.feed.pauseWhenHidden = config.feed['ESG_pauseWhenHidden'] === 'YES';
// this is an embed feature, not a player feature, so we process this ESG_flag in createPlayer instead of here.
// config.feed.frameBreak = config.feed['ESG_enableFrameBreak'] === 'YES';
config.feed.scrollDelay = config.feed['ESG_delayStartOnScroll'] === 'YES';
config.feed.loopPlaylist = config.feed['ESG_loopPlaylist'] === 'YES';
config.feed.titlePrepend = config.feed['ESG_titlePrepend'] || '';
config.feed.adPlacement = config.feed['LR_placementType'] || 'Premium';
config.feed.c_id = config.feed['C_ID'];
config.feed.enableEngagementLogging = config.feed['ESG_enableEngagementLogging'] === 'YES';

config.feed.forceClickToPlay = config.feed['ESG_forceClickToPlay'] === 'YES';
if(config.feed.forceClickToPlay)
{
	config.feed.autoplay = false;
	config.feed.playOnVisible = false;
	config.feed.floatOnLoad = false;
}

config.feed.insecureImaFrame = config.feed['ESG_insecureImaFrame'] === 'YES';

if(config.feed.enableResonate)
{
	installResonateLoader(window);
	resonateAnalytics.load();
}

let playerCreated = false;

config.intersectionObserver = new IntersectionObserver
(
	(entries) =>
	{
		entries.forEach
		(
			entry =>
			{
				const visibleValue = (entry.intersectionRatio*100);
				config.ac_id.outsideViewPort = visibleValue < (config.feed.playOnVisiblePercent);

				entry.target.setAttribute('data-visible',visibleValue.toFixed(1));

				// check if rootBounds exists before doing any above or below viewport class tagging
				// will be null in a hostile iframe and cause a crash
				// but we don't float in a hostile iframe anyways
				if(entry.rootBounds)
				{
					if (entry.isIntersecting)
					{
						if (entry.boundingClientRect.bottom !== entry.intersectionRect.bottom)
						{
							entry.target.classList.add('s2nBelowViewport');
						}
						else
						{
							entry.target.classList.remove('s2nBelowViewport');
						}
						if (entry.boundingClientRect.top !== entry.intersectionRect.top)
						{
							entry.target.classList.add('s2nAboveViewport');
						}
						else
						{
							entry.target.classList.remove('s2nAboveViewport');
						}
					}
					else
					{
						entry.target.classList.toggle('s2nBelowViewport', entry.boundingClientRect.top > 0);
						entry.target.classList.toggle('s2nAboveViewport', entry.boundingClientRect.top < entry.rootBounds.height);
					}
				}

				if(!playerCreated)
				{
					playerCreated = true;
					new VideoPlayer(document.body)
				}
			}
		)
	},
	{
		threshold: [...Array(21)].map((v,i,a) => i/(a.length-1))
	}
);

config.intersectionObserver.observe(config.divTag);

if(config.imaLatestVersion)
{
	compareIma();
}
else
{
	config.imaLatestVersionOnSet.push(compareIma);
}

function compareIma()
{
	config.scripts.ima.then
	(
		() =>
		{
			if(config.debug && config.imaLatestVersion !== google.ima.VERSION)
			{
				console.warn('Ima Version Mismatch - Library Update Available ( ' + google.ima.VERSION + ' => ' + config.imaLatestVersion + ' )');
			}
		}
	);
}
